import React from 'react';
import { ChevronRightIcon, StarIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const Hero = () => {
  return <section className="relative bg-benefika-charcoal text-white py-24 md:py-32 overflow-hidden" data-id="element-184">
      {/* Abstract Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-185">
        <div className="absolute -top-20 -right-20 w-96 h-96 rounded-full bg-benefika-teal opacity-20 blur-[100px]" data-id="element-186"></div>
        <div className="absolute top-40 -left-20 w-80 h-80 rounded-full bg-benefika-amber opacity-20 blur-[80px]" data-id="element-187"></div>
        <div className="absolute bottom-0 right-1/4 w-64 h-64 rounded-full bg-benefika-emerald opacity-10 blur-[60px]" data-id="element-188"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-189">
        <div className="max-w-4xl mx-auto text-center" data-id="element-190">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-8 border border-white/10" data-id="element-191">
            <StarIcon className="text-benefika-gold w-4 h-4" data-id="element-192" />
            <span className="text-sm font-medium text-benefika-light" data-id="element-193">
              Expertos en Fidelización
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-4xl md:text-6xl lg:text-7xl font-extrabold mb-6 leading-tight" data-id="element-194">
            Soluciones de fidelización que transforman{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-benefika-teal to-benefika-emerald" data-id="element-195">
              clientes o usuarios en fans
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg md:text-xl mb-10 text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-196">
            Potenciamos la relación con tus clientes, usuarios o grupos
            relacionados mediante programas de beneficios innovadores,
            plataformas digitales y estrategias de retención a largo plazo.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-197">
            <a href="#servicios" className="bg-benefika-teal hover:bg-benefika-emerald text-white font-semibold px-8 py-4 rounded-full transition-all shadow-lg hover:shadow-xl hover:-translate-y-1 inline-flex items-center justify-center" data-id="element-198">
              Descubrir servicios
              <ChevronRightIcon size={20} className="ml-2" data-id="element-199" />
            </a>
            <a href="/programas-clientes" className="bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/20 text-white font-semibold px-8 py-4 rounded-full transition-all inline-flex items-center justify-center" data-id="element-200">
              Ver casos de éxito
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
};
export default Hero;